<template>
  <div class="chatArea">
    <iframe
      ref="iframeRef"
      class="ca_iframe"
      allow="camera *; microphone *;display-capture;midi;encrypted-media;"
      :src="src"
    ></iframe>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userId: this.$route.query.userid,
      org: this.$route.query.org,
      oid: this.$route.query.oid,
      type: this.$route.query.type,
      src:`https://cloud.cocorobo.hk/aigpt/#/poc?muti_agent_id=90bec943-65cf-11ef-9db4-12e77c4cb76b&isPbl=false`
    };
  },
  methods: {},
  mounted() {
   this.src = `https://cloud.cocorobo.hk/aigpt/#/poc?muti_agent_id=90bec943-65cf-11ef-9db4-12e77c4cb76b&isPbl=false&session_id=${this.userId}-chat`
  }
};
</script>

<style scoped>
.chatArea {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}

.ca_iframe {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/pocAiClassroom/chatArea2.vue